import { useAppForm as useAppFormBase } from '@/components/custom/form'
import { useFormI18n } from './form-i18n'

/**
 * Wrap the base form hook so the validation-message setup only loads on routes that render a form. It
 * installs valibot's global messages, which need no locale pack — see `form-i18n.ts`.
 *
 * ⚠️ ASYNC-LOADED EDIT FORMS: `defaultValues` are read ONCE, at mount, so a form mounted while its query
 * is still loading silently fails validation on any field touched before the data arrives. Use a `key`ed
 * wrapper encoding both the record id and whether the data is ready — see docs/notes/app/use-app-form.md.
 */
// Takes the options object as ONE named parameter rather than `(...args)`: the React Compiler cannot
// lower spread syntax in hook arguments. `typeof useAppFormBase` still pins the signature.
export const useAppForm: typeof useAppFormBase = (options) => {
  useFormI18n()
  return useAppFormBase(options)
}
